import React from 'react';

import Box from '../Box'

export default props => {
    return (
        <section className="container">
            <Box {...props} id="b1" type="AHardcoverTile" settings={props.settings.b1} classes="" />
        </section>
    );
}
